module.exports = __webpack_public_path__ + "static/media/presupuestogratuito.1278f807.jpg";